import { getPartnerPanAction, getPartnerGstAction, getTeamPanAction, getTeamAddharAction, getPartnerBankAction } from "./action";

const initialState = {
  Pan: null,
  Gst: null,
  TeamPan: null,
  TeamAdd: null,
  Bank: null

};

const PanDocsReducer = (state = initialState, action) => {
  switch (action.type) {
    case getPartnerPanAction.GET_PARTNER_PAN_SUCCESS:
      return {
        ...state,
        Pan: action.payload.data,
      };

    case getPartnerPanAction.GET_PARTNER_PAN_ERROR:
      return {
        ...state,
        Pan: [],
      };

    case getTeamPanAction.GET_TEAM_PAN_SUCCESS:
      return {
        ...state,
        TeamPan: action.payload.data,
      };

    case getTeamAddharAction.GET_TEAM_ADDHAR_ERROR:
      return {
        ...state,
        TeamAdd: [],
      };

    case getTeamAddharAction.GET_TEAM_ADDHAR_SUCCESS:
      return {
        ...state,
        TeamAdd: action.payload.data,
      };

    case getTeamPanAction.GET_TEAM_PAN_ERROR:
      return {
        ...state,
        TeamPan: [],
      };

    case getPartnerGstAction.GET_PARTNER_GST_SUCCESS:
      return {
        ...state,
        Gst: action.payload.data,
      };

    case getPartnerGstAction.GET_PARTNER_GST_ERROR:
      return {
        ...state,
        Gst: [],
      };


    case getPartnerBankAction.GET_PARTNER_BANK_SUCCESS:
      return {
        ...state,
        Bank: action.payload.data,
      };

    case getPartnerBankAction.GET_PARTNER_BANK_ERROR:
      return {
        ...state,
        Bank: [],
      };




    default:
      return state;
  }
};

export default PanDocsReducer;
